export const SearchProductIcon = (): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="64.25" height="64" viewBox="0 0 64.25 64">
		<g>
			<path fill="none" d="M0 0H64V64H0z" transform="translate(-651 -3463) translate(651 3463)" />
			<g transform="translate(-651 -3463) translate(-198 3031.612)">
				<rect width="46" height="47.552" fill="#29e075" rx="4" transform="translate(849 440.388)" />
				<path
					fill="#592b86"
					stroke="#592b86"
					strokeWidth="0.5px"
					d="M14.231 10A4.235 4.235 0 0 0 10 14.231v41.46h25.82L34.974 54H11.692V14.231a2.543 2.543 0 0 1 2.538-2.538h42.307a2.543 2.543 0 0 1 2.538 2.538V39.2l1.693 1.7V14.231A4.235 4.235 0 0 0 56.537 10zm5.814 13.211a1.692 1.692 0 1 0 1.692 1.689 1.691 1.691 0 0 0-1.693-1.689zm4.231.846v1.692h24.537v-1.692zm-4.232 5.923a1.692 1.692 0 1 0 1.692 1.692 1.691 1.691 0 0 0-1.692-1.692zm4.231.846v1.692h24.538v-1.692zm24.647 6.25a11.846 11.846 0 1 0 7.747 20.786l1.573 1.577-.2.2a1.861 1.861 0 0 0 0 2.618l6.432 6.432a1.864 1.864 0 0 0 2.618 0l1.593-1.593a1.864 1.864 0 0 0 0-2.618l-6.432-6.432a1.859 1.859 0 0 0-2.618 0l-.2.2-1.577-1.573a11.829 11.829 0 0 0-8.941-19.593zm0 1.692a10.154 10.154 0 1 1-10.154 10.154 10.139 10.139 0 0 1 10.154-10.154zm-28.878-2.02a1.692 1.692 0 1 0 1.692 1.692 1.691 1.691 0 0 0-1.692-1.691zm4.231.846v1.692h11l.846-1.692zm36.671 21.6a.165.165 0 0 1 .112.05l6.432 6.432a.147.147 0 0 1 0 .225l-1.59 1.59a.147.147 0 0 1-.225 0l-6.432-6.432a.147.147 0 0 1 0-.225l1.593-1.593a.146.146 0 0 1 .11-.05z"
					transform="translate(843.776 423.388)"
				/>
			</g>
		</g>
	</svg>
)

export const ChevronDownIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="31.995" height="31.995" viewBox="0 0 31.995 31.995">
		<path fill="none" d="M0 0h32v32H0z" />
		<path
			fill="none"
			stroke="#833ec6"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="4px"
			d="M6 9l8 8 8-8"
			transform="translate(1.999 3.998)"
		/>
	</svg>
)
